import React from 'react';
import '../RSAShared.css';
import './RSAExistingAnalysis.css';
import RSAAnalysis from '../RSAAnalysis';

function RSAExistingAnalysis(props) {
  return <RSAAnalysis {...props} projectType="rsa-existing" />;
}

export default RSAExistingAnalysis;
